<template>
    <div v-if="dates.length > 0">
        <LoadingOverlay
            id="dates-loading-overlay"
            v-if="this.loading"
        ></LoadingOverlay>
        <AlertBox id="tickets-alert-box" ref="alertBox"></AlertBox>
        <div
            class="row my-5 my-md-4"
            v-for="(date, index) in pageOfItems"
            :key="'date-' + date.code + '_' + index"
        >
            <div
                class="col-12 col-md-1 pr-md-0 text-center d-flex flex-column"
                v-if="isAdmin"
            >
                <div class="row flex-fill">
                    <div class="col">
                        <button
                            class="cancel-date btn btn-secondary text-white h-100 w-100 py-2 py-md-0"
                            :title="getCancelEventButtonLabel(date)"
                            @click="cancelDate(date)"
                            :disabled="date.is_cancelled == 1"
                        >
                            <i class="fas fa-calendar-times"></i>
                            <span class="d-block d-md-none">{{
                                getCancelEventButtonLabel(date)
                            }}</span>
                        </button>
                    </div>
                </div>
                <div class="row flex-fill">
                    <div class="col">
                        <button
                            class="mark-date-has-complete btn btn-secondary text-white h-100 w-100 py-2 py-md-0"
                            :title="
                                date.isFull
                                    ? trans('course.dates.mark_as_not_complete')
                                    : trans('course.dates.mark_as_complete')
                            "
                            @click="toggleIsComplete(date)"
                            :disabled="date.is_cancelled == 1"
                        >
                            <i class="fas fa-users"></i>
                            <span
                                class="d-block d-md-none"
                                v-if="date.isFull"
                                >{{
                                    trans('course.dates.mark_as_not_complete')
                                }}</span
                            >
                            <span class="d-block d-md-none" v-else>{{
                                trans('course.dates.mark_as_complete')
                            }}</span>
                        </button>
                    </div>
                </div>
                <div class="row flex-fill">
                    <div class="col">
                        <button
                            class="create-event btn btn-secondary text-white h-100 w-100 py-2 py-md-0"
                            :title="getCreateEventButtonLabel(date)"
                            @click="createEvent(date)"
                            :disabled="
                                date.is_cancelled == 1 ||
                                date.isFull ||
                                date.is_saved
                            "
                        >
                            <i class="fas fa-calendar-plus"></i>
                            <span class="d-block d-md-none">{{
                                getCreateEventButtonLabel(date)
                            }}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4 px-md-2">
                <div
                    class="course-schedule bg-primary text-white py-4 py-md-2 text-center h-100 rounded"
                >
                    <div class="row align-items-center h-100">
                        <div class="date col-12 col-md-5">
                            <div class="day-name text-capitalize">
                                {{
                                    mixins.methods.dateDayFullText(
                                        date.start_datetime,
                                        date.timezone,
                                        course.is_online
                                    )
                                }}
                            </div>
                            <div class="day-number">
                                {{
                                    mixins.methods.dateDayNumber(
                                        date.start_datetime,
                                        date.timezone,
                                        course.is_online
                                    )
                                }}
                            </div>
                            <div class="month-and-year">
                                {{
                                    mixins.methods.dateMonthAndYear(
                                        date.start_datetime,
                                        date.timezone,
                                        course.is_online
                                    )
                                }}
                            </div>
                        </div>
                        <div class="hours col-12 col-md">
                            <div
                                class="start pt-2"
                                v-html="
                                    mixins.methods.hour(
                                        date.start_datetime,
                                        date.timezone,
                                        course.is_online
                                    )
                                "
                            ></div>
                            <div
                                class="end mt-2"
                                v-html="
                                    mixins.methods.hour(
                                        date.end_datetime,
                                        date.timezone,
                                        course.is_online
                                    )
                                "
                            ></div>
                            <div class="timezone mt-2 font-italic">
                                {{ userTimezone }}
                            </div>
                            <div class="timezone-modal-opener">
                                <button
                                    type="button"
                                    class="btn btn-link text-white p-0"
                                    data-toggle="modal"
                                    data-target="#timezone-chooser-modal"
                                >
                                    <small>
                                        <u>
                                            {{
                                                app.locale.trans(
                                                    'course.timezone.button_change'
                                                )
                                            }}
                                        </u>
                                    </small>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-2 px-md-0">
                <div
                    class="bg-light course-bought-tickets px-2 py-3 py-md-2 rounded"
                >
                    {{
                        app.locale.trans(date.statusLabel, {
                            ':registered_users': date.boughtTicketsCount,
                            ':course_maximum_number_participants':
                                course.max_event_size,
                        })
                    }}
                </div>
            </div>
            <div class="col pl-md-2">
                <div class="justify-content-beetween h-100">
                    <div class="row h-100">
                        <div
                            is="booking-online-ticket"
                            v-for="ticket in tickets"
                            v-bind:key="index + '_' + ticket.id"
                            v-bind:ticket="ticket"
                            v-bind:event="date"
                            v-bind:isCourseFull="
                                date.boughtTicketsCount >
                                    course.max_event_size ||
                                date.boughtTicketsCount == course.max_event_size
                            "
                            v-bind:isBookable="date.isBookable"
                            v-bind:economicViability="course.economic_viability"
                            v-bind:isAdmin="isAdmin"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
        <nav aria-label="Dates navigation">
            <pagination :items="dates" @changePage="onChangePage"></pagination>
        </nav>
    </div>
    <div v-else class="card">
        <div class="card-body bg-light">
            {{ app.locale.trans('course.dates.not-scheduled') }}
        </div>
    </div>
</template>

<script>
import AlertBox from './../../../../vue/AlertBox.vue';
import BookingOnlineTicket from './BookingOnlineTicket.vue';
import CartApiService from './../../../../class/service/CartApiService';
import LoadingOverlay from './../../../../vue/LoadingOverlay.vue';
import Pagination from './../../../../vue/Pagination.vue';
import MixinsVue from './../../../../mixins/Vue.js';
import axios from 'axios';

export default {
    props: {
        courseJson: String,
        ticketsJson: String,
    },

    data() {
        let token = document.querySelector('meta[name="csrf-token"]').content;
        let isAdmin = document.querySelector('meta[name="is-admin"]').content != '';
        let course = JSON.parse(this.courseJson);
        let tickets = JSON.parse(this.ticketsJson);
        let userTimezone = this.app.locale.getUserTimezone();
        let cartApiService = new CartApiService();

        // Retrieve dates from the course
        let dates = [];
        for (let date of course.events) {
            dates.push(date);
        }

        return {
            cartApiService: cartApiService,
            currentPage: 1,
            maxPage: null,
            mixins: MixinsVue.methods.vue,
            userTimezone: userTimezone,
            token: token,
            isAdmin: isAdmin,
            course: course,
            tickets: tickets,
            dates: dates,
            loading: false,
            pageOfItems: [],
        };
    },

    components: {
        AlertBox,
        LoadingOverlay,
        BookingOnlineTicket,
        Pagination,
    },

    methods: {
        cancelDate: function (event) {
            axios
                .post(
                    '/api/courses/dates/cancel',
                    {
                        event: event,
                        city_id: null,
                    },
                    {
                        headers: {
                            'X-CSRF-TOKEN': this.$parent.token,
                        },
                    }
                )
                .then(
                    (success) => {
                        if (success.data.success) {
                            document.location.reload();
                            this.$refs.alertBox.showAlertMessage(
                                app.locale.trans(success.data.message)
                            );
                        } else {
                            this.$refs.alertBox.showAlertMessage(
                                app.locale.trans(success.data.message)
                            );
                        }
                    },
                    (error) => {
                        this.$refs.alertBox.handleError(error);
                    }
                );
        },

        toggleIsComplete: function (event) {
            axios
                .post(
                    '/api/courses/dates/toggle-is-complete',
                    {
                        event: event,
                        city_id: null,
                    },
                    {
                        headers: {
                            'X-CSRF-TOKEN': this.$parent.token,
                        },
                    }
                )
                .then(
                    (success) => {
                        document.location.reload();
                        this.$refs.alertBox.showAlertMessage(
                            success.data.level,
                            app.locale.trans(success.data.transKey)
                        );
                    },
                    (error) => {
                        this.$refs.alertBox.handleError(error);
                    }
                );
        },

        createEvent: function (event) {
            axios
                .post(
                    '/api/events',
                    {
                        event: event,
                        city_id: null,
                    },
                    {
                        headers: {
                            'X-CSRF-TOKEN': this.$parent.token,
                        },
                    }
                )
                .then(
                    (success) => {
                        document.location.reload();
                        this.$refs.alertBox.showAlertMessage(
                            success.data.level,
                            app.locale.trans(success.data.transKey)
                        );
                    },
                    (error) => {
                        this.$refs.alertBox.handleError(error);
                    }
                );
        },

        getCreateEventButtonLabel(event) {
            if (event.is_saved) {
                return (
                    app.locale.trans('course.dates.event_exists') +
                    ' - ID: ' +
                    event.id
                );
            } else {
                return app.locale.trans('course.dates.create_event');
            }
        },

        getCancelEventButtonLabel(event) {
            if (event.is_cancelled == 1) {
                return app.locale.trans('course.dates.event_cancelled');
            } else {
                return app.locale.trans('course.dates.cancel');
            }
        },

        onChangePage(pageOfItems) {
            // Update page items
            this.pageOfItems = pageOfItems;
            
            // Find the original date objects to preserve their isBookable value
            for (let pageItem of this.pageOfItems) {
                const originalDate = this.dates.find(d => 
                    d.start_datetime === pageItem.start_datetime && 
                    d.id === pageItem.id
                );
                
                if (originalDate) {
                    pageItem.isBookable = originalDate.isBookable;
                }
            }
        },
    },
};
</script>
